import { render, staticRenderFns } from "./BotsList.vue?vue&type=template&id=3db34602&"
import script from "./BotsList.vue?vue&type=script&lang=ts&"
export * from "./BotsList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports